import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { reactI18nextModule } from 'react-i18next'
import moment from 'moment'
import 'moment/locale/pt-br'
import 'moment/locale/es'

// Mantém datas, durações e formato de hora do moment no mesmo idioma da interface
const toMomentLocale = (lng) => {
  const l = `${lng || ''}`.toLowerCase()
  if (l.indexOf('pt') === 0) return 'pt-br'
  if (l.indexOf('es') === 0) return 'es'
  return 'en'
}

const syncMomentLocale = (lng) => moment.locale(toMomentLocale(lng || i18n.language || 'pt-BR'))

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    backend: {
      loadPath: `locales/{{lng}}/{{ns}}.json?${new Date()}`,
    },
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    debug: false,
    react: {
      wait: true,
    },
  })

syncMomentLocale('pt-BR')
i18n.on('initialized', () => syncMomentLocale())
i18n.on('languageChanged', (lng) => syncMomentLocale(lng))

export default i18n
